import {Component, ElementRef, ViewChild} from '@angular/core';
import {BaseComponent} from '../base-overlay/base.component';
import {selectCurrentTimeFromState} from '../../../shared/stores/root-store/selectors/video.selector';
import {
    distinctUntilChanged,
    filter,
    map,
    takeUntil,
    tap
} from 'rxjs/operators';
import {SetVideoStateTypeAction} from '../../../shared/stores/root-store/actions/video.action';
import {VideoStateEnum} from '../../../../enums/video-state.enum';
import {SendAction} from '../../../shared/stores/root-store/actions/external-actions.action';

@Component({
    selector: 'eocm-image',
    templateUrl: './image-overlay.component.html',
    styleUrls: ['./image-overlay.component.scss', '../../overlay.component.scss']
})
export class ImageOverlayComponent extends BaseComponent {
    useFallbackImage = false;
    private isStable = false;

    private hiddenImage: ElementRef<HTMLImageElement>;

    @ViewChild('hiddenImage', {
        static: false
    }) set imageElement(elementRef: ElementRef<HTMLImageElement>) {
        if (!elementRef) {
            return;
        }

        this.hiddenImage = elementRef;
        this.hiddenImage.nativeElement.onerror = () => {
            this.useFallbackImage = true;
        }
    }

    ngOnInit() {
        super.ngOnInit();
        if (this.overlay.pauseOnShow) {
            this.store.select(selectCurrentTimeFromState).pipe(
                tap(currentTime => this.isStable = this.overlayService.isStable(currentTime, this.overlay)),
                map(() => this.isStable && this.isVisible),
                distinctUntilChanged(),
                filter(Boolean),
                takeUntil(this.destroy$)
            ).subscribe(() => {
                this.store.dispatch(SetVideoStateTypeAction({
                    videoState: VideoStateEnum.Interaction
                }))
            });
        }
    };

    override onClick(event: MouseEvent) {
        event.stopPropagation();

        if (!this.hasEventsToTrack()) {
            this.store.dispatch(SetVideoStateTypeAction({
                videoState: VideoStateEnum.UserPause
            }))
            return;
        }

        const hasNavigation = Boolean(this.overlay.navigateTo);

        this.trackEvent();
        this.executeActions();

        if (hasNavigation) {
            this.navigate();
        }
    }

    override getStyle(isHover: boolean = false, useFallbackImage: boolean = false) {
        return this.overlayService.getStyle(this.overlay, this.position, isHover, this.isVisible, useFallbackImage);
    }

    private executeActions() {
        this.overlay.actions?.forEach(actionId => {
            this.store.dispatch(SendAction({
                actionId
            }))
        });
    }

    private hasEventsToTrack() {
        return !!this.overlay.navigateTo;
    }

}
